import { makeStyles } from '../../../state/hooks';

export default makeStyles()(theme => ({
    tableCell: {
        textAlign: 'center',
        backgroundColor: theme.palette.neutrals[50],
    },
}));
